"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideSensitive = void 0;
const isObject = (value) => {
    return typeof value === 'object' && value !== null;
};
/**
 * Determines whether or not an input is a stringified object.
 * Returns a tuple indicating whether the input is a json object along with the parsed value (if parsing succeeded).
 */
const isJSONString = (input) => {
    if (typeof input !== 'string') {
        return [false];
    }
    let value;
    try {
        value = JSON.parse(input);
    }
    catch (e) {
        return [false];
    }
    if (isObject(value)) {
        return [true, value];
    }
    return [false];
};
function hideSensitive(obj, sensitiveKeys = []) {
    if (obj === undefined || obj === null) {
        return obj;
    }
    if (typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((val) => hideSensitive(val, sensitiveKeys));
    }
    const newObj = {};
    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        if (Array.isArray(value)) {
            newObj[key] = hideSensitive(value, sensitiveKeys);
        }
        else if (typeof value !== 'object') {
            if (sensitiveKeys.includes(key)) {
                newObj[key] = '***';
            }
            else if (typeof value === 'string') {
                const [isJSON, jsonValue] = isJSONString(value);
                newObj[key] = isJSON ? hideSensitive(jsonValue, sensitiveKeys) : value;
            }
            else {
                newObj[key] = value;
            }
        }
        else if (typeof value === 'object') {
            newObj[key] = hideSensitive(value, sensitiveKeys);
        }
        else {
            newObj[key] = value;
        }
    });
    return newObj;
}
exports.hideSensitive = hideSensitive;
//# sourceMappingURL=index.js.map